


// Generated from io.spcfy.orders.samplemeta.enums.MatrixType

export type MatrixTypeKey =
  "ARTHROPODS" |
  "SOIL" |
  "WOOD" |
  "FECES" |
  "WATER" |
  "AIR" |
  "ENVIRONMENTAL";


export interface MatrixTypeDTO {
  key: MatrixTypeKey;
  label: string;    
}


export const MatrixTypes: Record<MatrixTypeKey, MatrixTypeDTO> = {
  ARTHROPODS: { key: "ARTHROPODS", label: "Arthropods" },
  SOIL: { key: "SOIL", label: "Soil" },
  WOOD: { key: "WOOD", label: "Wood" },
  FECES: { key: "FECES", label: "Feces" },
  WATER: { key: "WATER", label: "Water" },
  AIR: { key: "AIR", label: "Air" },
  ENVIRONMENTAL: { key: "ENVIRONMENTAL", label: "Environmental" }
};
